import './components/desktop-menu/desktop-menu-modal.js'
import './components/desktop-menu/desktop-menu.js'
import './components/accordion-container/accordion-container.js'
import './components/menu-button/menu-button.js'
import './components/carousel/carousel.js'
import './components/modal-container/modal-container.js'
import './components/mobile-menu/mobile-menu.js'
import './components/contextual-menu/contextual-menu.js'
import './components/highlight-text/highlight-text.js'
import './components/filter-container/filter-container.js'
import './components/list-container/list-container.js'
import './components/paging-container/paging-container.js'
import './components/large-dropdown/large-dropdown.js'
import './components/filter-search-box/filter-search-box.js'
import './components/search-result/search-result.js'
import './components/form-container/form-container.js'
import './components/contact-form-container/contact-form-container.js'
import './components/dropdown-container/dropdown-container.js'
import './components/conditional-field/conditional-field.js'
import './components/radio-group/radio-group.js'
import './components/form-steps/form-steps.js'
import './components/popover-box/popover-box.js'

import './base.css'
import './util.css'

import './foundation/icons/toggle-icon.js'
import './foundation/icons/search-icon.js'
import './foundation/icons/close-icon.js'
import './foundation/icons/globe-icon.js'
import './foundation/icons/user-icon.js'
import './foundation/icons/arrow-right.js'
import './foundation/icons/arrow-left.js'
import './foundation/icons/circle-information-icon.js'
import './foundation/icons/facebook-icon.js'
import './foundation/icons/linkedin-icon.js'
import './foundation/icons/youtube-icon.js'
import './foundation/icons/contact-icon.js'
import './foundation/icons/send-icon.js'
import './foundation/icons/handshake-icon.js'
import './foundation/icons/buildings-icon.js'
import './foundation/icons/presentation-icon.js'
import './foundation/icons/mail-exclamation-icon.js'
import './foundation/icons/whistle-icon.js'
import './foundation/icons/briefcase-icon.js'
import './foundation/icons/bank-icon.js'
import './foundation/icons/chevron-icon.js'
import './foundation/icons/arrow-square.js'
import './foundation/icons/map-icon.js'
import './foundation/icons/mail-icon.js'
import './foundation/icons/wallet-icon.js'
import './foundation/icons/calendar-icon.js'
import './foundation/icons/deadline-icon.js'
import './foundation/icons/play-icon.js'
import './foundation/icons/phone-icon.js'
import './foundation/icons/circle-exclamation-icon.js'
import './foundation/icons/ghost-smile.js'
import './foundation/icons/laptop-xmark.js'
import './foundation/icons/questionmark-icon.js'

import './patterns/form/form.js'

import './global/datalayer-push.js'

import './foundation/colors/colors.css'
import './foundation/colors/colors.theme.invest.css'
import './foundation/colors/colors.theme.default.css'
import './foundation/colors/colors.theme.inspiration.css'
import './foundation/colors/colors.theme.regions.css'
import './foundation/colors/colors.theme.alpidus.css'
import './foundation/colors/colors.theme.color.css'

import './foundation/type/type.css'
import './foundation/type/fonts.css'
import './foundation/type/tables.css'

import './layout/layout.css'
import './layout/header.css'
import './layout/header-mobile.css'
import './layout/main-nav.css'
import './layout/tools.css'
import './layout/main.css'
import './layout/util.css'
import './layout/contextual-nav.css'
import './layout/footer.css'

import './pages/start/article/article.css'
import './pages/start/search/search.css'

import './sections/contactform/contactform.css'

import './patterns/button/button.css'
import './patterns/dropdown-button/dropdown-button.css'
import './patterns/richtext/richtext.css'
import './patterns/content/content.css'
import './patterns/content-section/content-section.css'
import './patterns/content-list/content-list.css'
import './patterns/section/section.css'
import './patterns/grid/grid.css'
import './patterns/hero/hero.css'
import './patterns/card/card.css'
import './patterns/content-label/content-label.css'
import './patterns/card-small/card-small.css'
import './patterns/card-wide/card-wide.css'
import './patterns/card-text-below/card-text-below.css'
import './patterns/promotion-card-event/promotion-card-event.css'
import './patterns/promotion-card/promotion-card.css'
import './patterns/image-overlay/image-overlay.css'
import './patterns/faq/faq.css'
import './patterns/inline-faq/inline-faq.css'
import './patterns/signup/signup.css'
import './patterns/form/optimizely.css'
import './patterns/form/form.css'
import './patterns/form/radio-group.css'
import './patterns/topic/topic.css'
import './patterns/region-dropdown/region-dropdown.css'
import './patterns/page-hero/page-hero.css'
import './patterns/page-hero/page-hero-regions.css'
import './patterns/hero-page-image/hero-page-image.css'
import './patterns/hero-articlepage-image/hero-articlepage-image.css'
import './patterns/article-summary/article-summary.css'
import './patterns/breadcrumbs/breadcrumbs.css'
import './patterns/divider/divider.css'
import './patterns/quote/quote.css'
import './patterns/image/image.css'
import './patterns/image-grid/image-grid.css'
import './patterns/card-cta/card-cta.css'
import './patterns/filter/filter.css'
import './patterns/featured-cards/featured-cards.css'
import './patterns/usp/usp.css'
import './patterns/icon-card/icon-card.css'
import './patterns/statistics/statistics.css'
import './patterns/joblist/joblist.css'
import './patterns/details/details.css'
import './patterns/date-banner/date-banner.css'
import './patterns/gallery/gallery.css'
import './patterns/video/video.css'
import './patterns/container/container.css'
import './patterns/facts-card/facts-card.css'
import './patterns/alert-message/alert-message.css'

import './global/third-party.css'

/* Todo: Exclude from main bundle */
import './_styleguide/elements/nav-container.js'
import './_styleguide/elements/almi-logotype.js'
import './_styleguide/elements/component-canvas.js'

import { listen } from 'quicklink'

window.addEventListener('load', () => {
  listen()
})
